// extracted by mini-css-extract-plugin
export default {"pageLayout":"ExternalJobBoards-module__pageLayout___yefT0"};